import React from 'react';
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { AppLocaleProvider, AppLocaleData } from 'sd-ui-components';

const { IntlProvider, addLocaleData } = AppLocaleProvider;
const { en } = AppLocaleData;

/**
 * Each locale which we wish to make available in the app must be imported and added here.
 */
addLocaleData([...en]);

/**
 * This component ensures that the app messages are loaded before rendering the app.
 *
 * IntlProvider does not react to changes in MobX stores, so it is necessary to wrap it in
 * a component which can react to changes.
 */
@inject('MessagesStore')
@inject('LocalizationStore')
@observer
class Localization extends Component {
  render() {
    let children;
    const userLocale = this.props.LocalizationStore.locale;

    if (this.props.MessagesStore.messagesLoaded) {
      children = (
        <IntlProvider
          locale={userLocale}
          messages={this.props.MessagesStore.messages}
        >
          {this.props.children}
        </IntlProvider>
      );
    }

    return <div>{children}</div>;
  }
}

export default Localization;



// WEBPACK FOOTER //
// ./src/containers/Localization/Localization.jsx